/**
 * The Sandbox's own wording, in one place.
 *
 * The word appears in the navigation, on the service page's button, as the
 * page's own title and on the banner above the form, and it has to be the same
 * word every time: somebody who reads «اجرای آزمایشی» in the menu and then
 * lands on a page headed something else has to stop and work out whether they
 * are in the right place — on the one screen in the portal that spends their
 * money.
 *
 * The Latin word is kept beside the Persian deliberately. "Sandbox" is what the
 * documentation, the SDK and every other platform call it, and a customer
 * searching for it will search for that.
 */
export const SANDBOX_LABEL = {
  /** The navigation entry and the button that opens it. */
  action: 'اجرای آزمایشی (Sandbox)',
  /** The page's own heading. */
  heading: 'اجرای آزمایشی — Sandbox',
  /** The banner that must be impossible to miss. */
  warning:
    'این یک فراخوانی واقعی است. همان مسیری اجرا می‌شود که اپلیکیشن‌های شما استفاده می‌کنند: دسترسی بررسی می‌شود، درخواست ثبت می‌شود و بهای آن از کیف پول شما برداشت می‌شود.',
} as const
